import { render } from "./advertisingCenter.vue?vue&type=template&id=462930fa&scoped=true"
import script from "./advertisingCenter.vue?vue&type=script&lang=js"
export * from "./advertisingCenter.vue?vue&type=script&lang=js"

import "./advertisingCenter.vue?vue&type=style&index=0&id=462930fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.32_vue@3.4.32_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462930fa"]])

export default __exports__